import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Not every business needs a full IT department — but every business needs reliable help when something breaks. Our on-demand IT support gives you responsive expertise on a flexible basis.",
    "From quick fixes to hands-on projects, we're available when you need us and out of the way when you don't.",
];

const FEATURES = [
    { title: "Responsive help", text: "Fast support when issues arise, without waiting on a fixed contract." },
    { title: "Flexible engagement", text: "Pay for what you need, scaling with real demand." },
    { title: "Broad expertise", text: "Servers, networks, software and hardware covered by one team." },
    { title: "No lock-in", text: "Support on your terms, with no long-term commitment required." },
];

const CHECKS = [
    "Helpdesk & break-fix support",
    "Server & network help",
    "Software & hardware support",
    "Remote & on-call assistance",
    "Project-based IT work",
];

export default function OnDemandItSupportServices() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="On-Demand IT Support" eyebrowAs="span">
                    IT support exactly when you need it — flexible, responsive help without a long-term commitment.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
